import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Tag, TagType } from '../entities/tags.entity';

export const tagsActions = createActionGroup({
  source: 'Tags',
  events: {
    'Load Tags': props<{ tagType: TagType }>(),
    'Delete Tag': props<{ tagId: string }>(),
    'Activate All Tags': emptyProps(),
    'Toggle Tag': props<{ tagId: string }>(),
    'Reset Tags': emptyProps(),
    'Preset Activated Tags': props<{ tagIds: string[] }>(),
    'Set Currently Editing Entity Id': props<{ entityId: string }>(),
    'Reset Currently Editing Entity Id': emptyProps(),
    'Delete Linked Tag': props<{ tagId: string; entityId: string }>(),
    'Add Tag': props<{ tagId: string; entityId: string; name: string }>(),
    'Clear Errors': emptyProps(),
  },
});

export const tagsApiActions = createActionGroup({
  source: 'Tags API',
  events: {
    'Load Position Tags Success': props<{ tags: Tag[] }>(),
    'Load Watchlist Tags Success': props<{ tags: Tag[] }>(),
    'Load Savings Tags Success': props<{ tags: Tag[] }>(),
    'Load Tags Failure': props<{ error: string }>(),
    'Delete Tag Success': props<{ tagId: string }>(),
    'Delete Tag Failure': props<{ error: string }>(),
    'Delete Linked Tag Success': props<{ tagId: string; entityId: string }>(),
    'Delete Linked Tag Failure': props<{ error: string }>(),
    'Add Tag Success': props<{ tag: Tag }>(),
    'Add Tag Failure': props<{ error: string }>(),
  },
});
